/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

class TemplatesUploadApi extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  upload(inboxId, file, mediaType = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (mediaType) formData.append('media_type', mediaType);

    return axios({
      method: 'post',
      url: `${this.url}/${inboxId}/templates/upload`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new TemplatesUploadApi();
